import { render, staticRenderFns } from "./Profile.component.vue?vue&type=template&id=2a3b6876&"
import script from "./Profile.component.vue?vue&type=script&lang=ts&"
export * from "./Profile.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports